import config from "config/config";

const bgStyles: Record<string, { color: string; bgImage: string }> = {
  primary: { color: "primary.500", bgImage: "none" },
  hills: {
    color: "primary.900",
    bgImage: `url(${config.staticUrl}/i/airhelp-plus/ahplus-landing-page-bg-fragment-triangles-02.svg)`,
  },
};

export default bgStyles;
